console.log('date-autocomplete load')

len = 0
last_char = ""

function init() {
  $('.date-autocomplete').on('input', function() {

    // If deletion.
    if (len > $(this).val().length) {
      
      if ($(this).val().slice(-1) === "/") {
        $(this).val($(this).val().slice(0, len - 1))
      }

    // If insertion.
    } else {

      if ($(this).val().slice(-1) === "/") {
        if ($(this).val().length !== 3 && $(this).val().length !== 6) {
          $(this).val($(this).val().slice(0, len))
        }
      }

      if ($(this).val().length === 2) {
        $(this).val($(this).val() + "/")
      } else if ($(this).val().length === 5) {
        $(this).val($(this).val() + "/")
      } else {
        
      }
    }

    len = $(this).val().length
    last_char = $(this).val().slice(-1)  
  });
}

$(document).ready(
  init()
);

$(document).on("turbolinks:load", function() {
  init()
});
